import React from "react";
import { Card, Field, makeStyles } from "@fluentui/react-components";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    position: "fixed",
    bottom: "0",
    width: "100%",
    textAlign: "center",
    borderRadius: "0em !important",
    boxShadow: "none",
    borderTop: "1px solid #dee1ea",
  },
});

const VersinCard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Card className={useStyles().root}>
      <Field>{t('version_text')} {process.env.VERSION}</Field>
    </Card>
  );
};

export default VersinCard;